import { useCallback } from 'react'
import { useFormContext, useFormState } from 'react-hook-form'

import * as S from './visitor-parking-phone-input.styled'
import { VisitorParkingPhoneInputProps } from './visitor-parking-phone-input.types'

const PhoneInputInfo = ({ error, extraInfo }: { extraInfo?: string; error?: string }) => {
  if (error) {
    return <S.ErrorMessage>{error}</S.ErrorMessage>
  }
  if (extraInfo) {
    return <S.ExtraInfo>{extraInfo}</S.ExtraInfo>
  }
  return null
}

export const VisitorParkingPhoneInput = ({
  label,
  name,
  extraInfo,
}: VisitorParkingPhoneInputProps) => {
  const { setValue, getValues, getFieldState } = useFormContext()
  const formState = useFormState({ name })
  const { error } = getFieldState(name, formState)

  const handleChange = useCallback(
    (value: string) => {
      // Note: shouldValidate triggers the schema validation (if form was ever submitted)
      setValue(name, value, {
        shouldValidate: formState.submitCount > 0,
      })
    },
    [name, setValue, formState.submitCount],
  )

  return (
    <S.Container>
      {label && <S.Label htmlFor={name}>{label}</S.Label>}
      <S.StyledPhoneInput
        $hasError={!!error}
        defaultCountry="US"
        initialValue={getValues(name)}
        name={name}
        onChange={handleChange}
      />
      <PhoneInputInfo error={error?.message} extraInfo={extraInfo} />
    </S.Container>
  )
}
